import { client } from 'graphql/client'
import { buyOutsQueries } from 'graphql/queries/entities/buyOutQueries'
import documentQueries from 'graphql/queries/userEntities/documentQueries'
import esopGrantQueries from 'graphql/queries/entities/esopGrantQueries'
import esopQueries from 'graphql/queries/entities/esopQueries'
import { payOutsQueries } from 'graphql/queries/entities/payOutQueries'
import { unfreeze } from 'utils'
import { investmentsQueries } from '../queries/entities/investmentQueries'
import { investorsQueries } from '../queries/entities/investorQueries'
import { modellingProjectsQueries } from '../queries/modellingProjectQueries'
import { projectInvitationQueries } from '../queries/userEntities/projectInvitationQueries'
import { projectMembershipQueries } from '../queries/userEntities/projectMembershipQueries'
import {
  GET_PROJECTS,
  GET_PROJECT,
  projectsQueries,
  GET_PROJECTS_EXITS,
} from '../queries/project/projectQueries'
import { roundsQueries } from '../queries/entities/roundQueries'
import { sharesQueries } from '../queries/entities/shareQueries'
import { userQueries, usersQueries } from '../queries/userEntities/userQueries'
import { manualSharesQueries } from '../queries/entities/manualSharesQueries'
import { calculationNodeQueries } from '../queries/calculationNodeQueries'
import esopSetupQueries from '../queries/entities/esopSetupQueries'

export function getQueries(namespace) {
  switch (namespace) {
    case 'investors':
      throw new Error(
        "Please use the 'stakeholders' namespace instead! (It will update investors as well)",
      )
    case 'calculationNode':
      return calculationNodeQueries
    case 'stakeholders':
      return investorsQueries
    case 'shares':
      return sharesQueries
    case 'rounds':
      return roundsQueries
    case 'investments':
      return investmentsQueries
    case 'projects':
      return projectsQueries
    case 'modellingProjects':
      return modellingProjectsQueries
    case 'projectMemberships':
      return projectMembershipQueries
    case 'projectInvitations':
      return projectInvitationQueries
    case 'user':
      return userQueries
    case 'users':
      return usersQueries
    case 'buyOuts':
      return buyOutsQueries
    case 'payOuts':
      return payOutsQueries
    case 'manualShares':
      return manualSharesQueries
    case 'esopGrants':
      return esopGrantQueries
    case 'esops':
      return esopQueries
    case 'esopSetup':
      return esopSetupQueries
    case 'projectDocuments':
      return documentQueries
    default:
      return {}
  }
}

/** ******************* CUSTOM Update functions ******************** */

export const updateDefaultInvestor = (changedDefaultInvestor, userId, updatedProjectId) => {
  // maps the membersships so the updated gets updated to changedDefaultInvestor
  const helper = (p) => {
    return p.projectMemberships.map((membership) => {
      if (membership.userAccount.userId !== userId) return membership

      return changedDefaultInvestor
    })
  }

  // Update project query
  const data = client.readQuery({ query: GET_PROJECT, variables: { projectId: updatedProjectId } })
  const project = unfreeze(data.project)
  project.projectMemberships = helper(project)
  client.writeQuery({
    query: GET_PROJECT,
    variables: { projectId: updatedProjectId },
    data: { project },
  })

  // Update projects queries
  const updateProjects = (query) => {
    const { projects } = client.readQuery({ query, variables: { userId } })
    const updatedProjects = projects.map((p) => {
      if (p.id !== updatedProjectId) return p

      const projectMemberships = helper(p)
      return {
        ...p,
        projectMemberships,
      }
    })

    client.writeQuery({
      query,
      variables: { userId },
      data: { projects: updatedProjects },
    })
  }

  updateProjects(GET_PROJECTS)
  try {
    updateProjects(GET_PROJECTS_EXITS)
  } catch (e) {
    // silence graphql-apollo invalid cache (https://www.apollographql.com/docs/react/caching/cache-interaction/#readquery)
    // Query only exists on Portfolio page
  }
}
